<template>
  <div  class="main_center">

    <div class="content">
      <el-form ref="form" :model="search" label-width="110px">
        <el-row>
          <el-col :span="4">
            <el-form-item label="年份：" label-width="75px">
              <el-select v-model="search.year" value-key="value" style="width:100%;"  @change="yearsChange">
                <el-option v-for="(item,index) in yearsList"
                           :key="index"
                           :label="item"
                           :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item label="项目所属机构：" props="projectCode" >
              <el-input   v-model="search.tendererName" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="项目名称："  >
              <el-input   v-model="search.bidName" clearable placeholder="请输入内容搜索" @keyup.enter.native="seachBtn"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5" >
            <el-form-item label="交易中心：">
              <el-select v-model="search.tradeId" clearable value-key="value" style="width:100%;" @change="seachBtn">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(item,index) in transactionCenterList" :key="index" :label="item.orgName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <div style="float:right;margin-right: 10px;margin-bottom: 10px">
            <el-button size="small" type="primary" style="margin-left:30px;" @click="seachBtn">搜索</el-button>
            <el-button plain size="small" type="primary" style="margin-left:10px;"  @click="reflash">重置</el-button>
          </div>
        </el-row>
      </el-form>
      <space :left="-16" :right="-16" :bottom="16" />
      <div style="margin-top:16px;">
        <el-button size="small" v-if="deleteBtnShow" icon="el-icon-delete" type="primary"
                   @click="deleteSelectItem()">批量删除
        </el-button>
        <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                   @click="selectAll(true)">全选
        </el-button>
        <el-button size="small" v-if="deleteBtnShow" icon="el-icon-success" type="primary"
                   @click="selectAll(false)">反选
        </el-button>
        <el-button size="small" v-if="hasBtnPermission('btn_open_and_estimate_record_delete')" :icon="deleteBtnShow?'el-icon-close':'el-icon-delete'" type="primary"
                   @click="triggerDeleteBtn">{{deleteBtnShow?'取消':'删除数据'}}
        </el-button>
      </div>
      <el-row :gutter="15" :style="{'min-height':tableMaxHeight}" v-loading="dataListLoading" >
        <el-col :span="6" v-for="(item,index) in tableData" style="min-width: 180px" :key="item.id" >
          <el-card class="projectCard">
            <div slot="header" class="clearfix">
              <span class="title" :title="item.bidName">{{item.bidName}}</span>
              <p class="deleteBtn" v-if="deleteBtnShow">
                <i :style="{'color':hasSelect(item.id)?'#5cb6ff':'#c0c4cc'}"  @click="triggerSelectItem(item.id)" :class="hasSelect(item.id)?'el-icon-circle-check':'el-icon-circle-close'"></i>
              </p>
            </div>
            <p class="info"><span>编号：</span><span :title="item.tradePlatfBidSectionCode">{{item.tradePlatfBidSectionCode}}</span></p>
            <p class="info"><span>开标时间：</span><span :title="item.bidopenTime">{{ formatDate(item.bidopenTime,'yyyy-MM-dd HH:mm') }}</span></p>
            <p class="info">
              <span>开标室：</span>
              <span class="activeColor" v-for="room in item.bidopenRooms" :key="room.id">
                {{room.name }}
              </span>
            </p>
            <p class="info">
              <span>评标室：</span>
              <span class="activeColor" v-for="room in item.estimateRooms" :key="room.id">
                {{room.name }}
              </span>
            </p>
            <p class="info"><span>所属机构：</span><span :title="item.tendererName">{{item.tendererName}}</span></p>
            <div style="clear: both"></div>
            <div class="btnWrapper">
              <el-button  size="small" type="text" v-if="hasBtnPermission('btn_jz_witness_record_open_show') && (item.hasRecord==3||item.hasRecord==1)"  @click="router_toOpen(item)">开标见证记录</el-button>
              <el-button  size="small" type="text" v-if="hasBtnPermission('btn_jz_witness_record_eval_show') && (item.hasRecord==3||item.hasRecord==2)"  @click="router_toEstimate(item)">评标见证记录</el-button>
            </div>
          </el-card>

        </el-col>
        <emptyInfo v-if="tableData.length == 0" :emptyMsg="'暂无记录'" ></emptyInfo>
      </el-row>

      <!-- <el-pagination background
                     layout="sizes, prev, pager, next"
                     :page-sizes="[pageSize, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination> -->
       <pagination
            class="limit"
            :page-sizes="[pageSize, 20, 50, 100]"
            :total="total"
            :page.sync="pageIndex"
            :limit.sync="pageSize"
            @pagination="paginationChange">
        </pagination>

    </div>
  </div>
</template>

<script>

  import emptyInfo from '@/components/empty-info';
  import {nearSixYearsList} from '@/utils/index';
  import space from '../../../common/components/space.vue';
  import Pagination from '@/components/Pagination.vue';

  export default {
  components: {
    emptyInfo,
    space,
    Pagination
  },
  data() {
    return {
      tableMaxHeight:( document.documentElement.clientHeight - 267 ) + 'px',
      dataListLoading: false,
      yearsList:[],
      search:{
         year:new Date().getFullYear(),
         bidName:"",//项目名称
         tendererName:"", //所属机构
         tradeId: '', // 交易中心ID
      },
      deleteBtnShow:false,
      selectDeleteList:[],

      form:{    //见证数据
        id: "",          //见证数据ID
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataGroup: "",   //是否关联项目  1:关联项目  2:关联标段
        dataType: "",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标开始时间
        evalStime: "",  //评标结束时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: "",
        project: {  //项目数据
          id: "",
          projectCode: "",   //项目编号
          projectName: "",   //项目名称
          tenderAgencyName: "", //招标代理机构名称
          tendererName:""   //招标人名称
        },
        bid:{ //标段数据
          tendererName:''//招标人名称
        },
      },
      pageSize:10,//每页条数
      pageIndex:1,//当前页
      total:0,//总条数
      tableData:[],
      multipleSelection: [],
      user:'', //角色类型
      formData:{},
      transactionCenterList: [],
    }
  },

  mounted() {
    const that = this;
    let resizeTag = true;
    window.onresize = () => {
      if(resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  created() {
    this.yearsList = nearSixYearsList(this.search.year)
    this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));
  },
  activated() {

      this.getDataList()
  },
  methods: {
    ifmove() {


      let hasBtnPermisson = this.hasBtnPermission("btn_open_and_estimate_record_delete");
      let tableMaxHeight = ( document.documentElement.clientHeight - 267 +  (hasBtnPermisson ? 0 : 33) ) + 'px';
      this.pageIndex = 1
      if(document.documentElement.clientHeight >900){
        this.pageSize = 12
      }else if(document.documentElement.clientHeight < 770){
        this.pageSize = 8
      }else{
        this.pageSize = 8
      }
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      // this.getDataList()

    },

    triggerDeleteBtn(){
      this.deleteBtnShow = !this.deleteBtnShow;
      this.selectDeleteList = [];
    },
    hasSelect(id){
      let index = this.selectDeleteList.indexOf(id);
      return index > -1
    },
    triggerSelectItem(id){
      let index = this.selectDeleteList.indexOf(id);
      if(index > -1){
        this.selectDeleteList.splice(index,1);
      }else{
        this.selectDeleteList.push(id)
      }
    },

    selectAll(flag){
      const that = this;
      this.list.forEach(item=>{
        let index = that.selectDeleteList.indexOf(item.id)
        if(flag && index == -1){
          that.selectDeleteList.push(item.id)
        }
        if(!flag){
          that.triggerSelectItem(item.id)
        }
      })
    },

    deleteSelectItem() {
      if (this.selectDeleteList.length > 0) {

        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('/tradding/traddingwitness/delete',{
            idList:this.selectDeleteList
          }).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getDataList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }
    },


    reflash() {
      this.pageIndex = 1;
      this.$refs['form'].resetFields();
      this.search = {
        year:new Date().getFullYear(),
        bidName:"",//项目名称
        tendererName:"", //所属机构
        tradeId: ''
      };
      this.yearsList = nearSixYearsList(this.search.year);
      this.getDataList()
    },
    yearsChange(val){
      this.yearsList = nearSixYearsList(val)
      this.getDataList()
    },

      getDataList(){ // 获取列表数据
        this.dataListLoading=true;
        this.$http.post('/tradding/traddingwitness/openAndEstimateList',{
          'page': this.pageIndex,
          'rows': this.pageSize,
          'searchKey': '',
          'filter': {
              "year":this.search.year,
              "bidName":this.search.bidName, //项目名称
              "tendererName":this.search.tendererName,//所属机构
              "tradeId": this.search.tradeId
          }
        }).then(res=>{
          this.dataListLoading=false;
          this.tableData=res.data.rows;
          this.total=res.data.total;


        })
    },

    seachBtn(){ //搜索按钮
      this.getDataList()
    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
    },

    //跳转到开标见证详页
    router_toOpen(item) {
      let route_name = "openBidWitness_view";
      this.$router.push({
        name:route_name,
        query:{
          id:item.bidCode,
          dataSource:item.dataSource
        }
      })


    },
    //跳转到评标记录详页
    router_toEstimate(item) {
      let route_name = "estimateBidWitness_view";
      this.$router.push({
        name:route_name,
        query:{
          id:item.bidCode,
          dataSource:item.dataSource
        }
      })

    }



  }
}
</script>


<style lang="less" scoped>

  .projectCard{

    /deep/ .el-card__body{
      padding: 0;
    }
    /deep/ .el-card__header{
      text-align: center;
      padding: 16px 16px 0px 16px;
    }
    .title{
      margin-bottom: 10px;
    }
  }


</style>
